<template>
	<v-alert
        :type="type"
		indeterminate
		v-show="showLocal"
      >{{message}}
	</v-alert>
</template>

<script>
export default {
	name: 'AlertBasic',
	props: {
		show: {
			type: Boolean,
			required: true,
			default: false,
		},
		message: {
			type: String,
			required: true,
			default: '',
		},
		type: {
			type: String,
			required: true,
			enum: ['info', 'success', 'warn', 'error'],
		},
	},
	data() {
		return {
			showLocal: this.show,
		}
	},
	watch: {
		show: {
			handler() {
				this.showLocal = this.show
				if (this.showLocal) {
					setTimeout(() => {
						this.showLocal = false
						this.emitShow(this.showLocal)
					}, 6000)
				}
			},
		},
	},
	methods: {
		emitShow(value) {
			this.$emit('updateShow', value)
		},
	},
}
</script>

<style>

</style>
